<app-generic-modal [isOpen]="openModal" (closeModal)="toggleModal()">
  <!-- Conteúdo inicial do modal -->
  <div class="mgm-modal-content" *ngIf="!showSuccessContent">
    <div class="mgm-modal-header">
      <h2>Enviar Convite</h2>
      <button (click)="toggleModal()">
        <img
          src="../../../../assets/icons/x-circle-icon.svg"
          alt="Ícone de fechar"
        />
      </button>
    </div>

    <img
      src="../../../../assets/images/mail-placeholder.svg"
      alt="Ilustração de envelope com desenho de uma pata azul"
      class="mgm-modal-image"
    />

    <p class="mgm-modal-title">
      Digite os e-mails para quem você deseja convidar para a Plataforma
      PremieRvet®!
    </p>
    <p class="mgm-modal-subtitle">Digite os e-mails separado por vírgula.</p>

    <span class="mgm-modal-textarea-label">E-mails</span>
    <textarea
      id="mgm-modal-textarea"
      class="mgm-modal-textarea"
      data-testid="mgm-modal-textarea-input"
      [formControl]="emailsControl"
      placeholder="Digite os e-mails separados por vírgula"
      [class.error]="emailsControl.invalid && emailsControl.touched"
    ></textarea>
    <div
      class="mgm-modal-error"
      *ngIf="emailsControl.invalid && emailsControl.touched"
    >
      <span>Por favor, insira e-mails válidos separados por vírgula</span>
    </div>

    <div class="mgm-modal-buttons">
      <button class="button button-link" (click)="toggleModal()">
        Cancelar
      </button>
      <button
        class="button button-primary"
        data-testid="mgm-modal-send-invite-button"
        (click)="sendInvites()"
        [disabled]="!isFormValid"
      >
        <span>Enviar Convite</span>
      </button>
    </div>

    <div class="mgm-modal-footer">
      <button
        class="button button-primary"
        data-testid="mgm-modal-copy-link-button"
        (click)="copyLink()"
      >
        <img
          src="../../../../assets/icons/copy-icon.svg"
          alt="Ícone de copiar"
        />
        <span>Copiar Link do Convite</span>
      </button>
    </div>
  </div>

  <!-- Conteúdo de sucesso após enviar convites -->
  <div class="mgm-modal-success" *ngIf="showSuccessContent">
    <div class="mgm-modal-success-content">
      <img
        src="../../../../assets/images/mail-sent_letter.svg"
        alt="Ilustração de envelope"
        class="mgm-modal-image"
      />

      <p class="mgm-modal-title">Convites enviados!</p>
      <p class="mgm-modal-subtitle">
        Algum convidado não recebeu a mensagem? Certifique de que eles chequem a
        Caixa de Spam.
      </p>
      <p class="mgm-modal-paragraph">
        Se precisar reenviar o convite, acesse a tela de
        <strong>Convites Enviados</strong> para enviar um novo convite.
      </p>

      <div class="mgm-list-addresses">
        <div class="mgm-list-addresses-header">
          <span>Lista dos endereços de e-mails enviados</span>
          <button
            class="button button-link"
            data-testid="mgm-modal-list-emails"
            (click)="toggleEmailsList()"
          >
            {{ showEmailsList ? 'Fechar' : 'Mostrar' }}
          </button>
        </div>

        <div class="mgm-list-addresses-content" *ngIf="showEmailsList">
          <div
            class="mgm-email-item"
            data-testid="mgm-modal-email-item"
            *ngFor="let email of getEmailsList(); let i = index"
          >
            <span class="mgm-email-address">{{ email }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mgm-modal-buttons">
      <button class="button button-link" (click)="toggleModal()">Fechar</button>
      <!-- <button class="button button-primary" (click)="goToSentInvites()">
        <span>Ver Convites Enviados</span>
      </button> -->
    </div>
  </div>
</app-generic-modal>
